<script context="module">
  export enum ULinkTypesEnum {
    Internal,
    Media,
    External,
  }
</script>

<script lang="ts">
  import type { IULink, LinkTargetType } from "../types";
  import { navigateTo } from "../general/routing";

  export let data: IULink;

  const href = data?.url;
  const target: LinkTargetType = data?.target || "_self";
  const linkType = data?.type;
  const withoutReload =
    linkType === ULinkTypesEnum.Internal && target !== "_blank";

  function onClick(event: MouseEvent) {
    if (withoutReload) {
      event.preventDefault();
      navigateTo(href);
    }
  }
</script>

{#if href && data?.name}
  <a
    on:click={onClick}
    {target}
    {href}
    rel={withoutReload ? "" : "noopener noreferrer"}
    {...$$restProps}
  >
    {#if $$slots.default}
      <slot />
    {:else}
      {data.name}
    {/if}
  </a>
{:else}
  <slot />
{/if}
